import React, { useState, useEffect } from "react";
import {
  Box,
  Modal,
  Button,
  TextField,
  Typography,
  Grid,
  InputBase,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "@mui/material/styles"; // Importa useTheme desde MUI
import { tokens } from "../../theme"; // Asegúrate de que tokens esté definido en tu tema
import {
  getDatosInterfolacionColar,
  getIdColar,
  getOneDatos,
  getReprintColar,
  putAddInterfolacion,
  validationclr,
} from "../../services/interfoliacion.services";
import dayjs from "dayjs";
import QRCode from "qrcode";
import ModalError from "../modalError";
import ModalCharge from "../modalCharge";
import ModalSuccess from "../modalSucces";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { toast } from "react-toastify";

const ModalInsertInterfo = ({ open, onClose, col }) => {
  const [productos, setProductos] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([{}]); // Estado para almacenar las filas seleccionadas
  const [searchValue, setSearchValue] = useState("");
  const [printerInfo, setPrinterInfo] = useState(""); // Estado para guardar la información de la impresora
  const [errorMessage, setErrorMessage] = useState(""); // Estado para guardar posibles errores
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [rows, setRows] = useState([{ id: 1, serie: "", descripcion: "" }]);
    const [serieValue, setSerieValue] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [colar, setcolar] = useState();

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [rowValidation, setRowValidation] = useState({});

  useEffect(() => {
  const fetchYValidar = async () => {
    if (selectedIndex === null) return;

    // Si borra o serie incompleta, limpiar todo
    if (!serieValue || serieValue.length !== 16) {
      setRowValidation(prev => ({ ...prev, [selectedIndex]: null }));
      setFieldErrors(prev => ({ ...prev, [`serie_${selectedIndex}`]: "" }));
      setRows(prevRows => {
        const newRows = [...prevRows];
        newRows[selectedIndex].descripcion = "";
        return newRows;
      });
      return;
    }

    try {
      // PASO 1: traer de calandra (lógica original)
      const response = await getOneDatos(serieValue);

      if (!response) {
        throw new Error("La serie no está registrada en calandra");
      }

      // PASO 2: validar que no tenga colar en interfoliación
      await validationclr(serieValue); // tu nueva función del api

      // Todo ok: cargar descripción y marcar válida
      setRowValidation(prev => ({ ...prev, [selectedIndex]: 'valid' }));
      setFieldErrors(prev => ({ ...prev, [`serie_${selectedIndex}`]: "" }));

      if (response?.cod) {
        setRows(prevRows => {
          const newRows = [...prevRows];
          newRows[selectedIndex].descripcion = response.cod;
          return newRows;
        });
      }

    } catch (error) {
      // Cualquier error: mostrar en el campo y bloquear
      setRowValidation(prev => ({ ...prev, [selectedIndex]: 'invalid' }));
      setFieldErrors(prev => ({
        ...prev,
        [`serie_${selectedIndex}`]: error?.message || "Serie inválida"
      }));
      setRows(prevRows => {
        const newRows = [...prevRows];
        newRows[selectedIndex].descripcion = "";
        return newRows;
      });
    }
  };

  fetchYValidar();
}, [serieValue, selectedIndex]);


  // // const handleRowClick = (params) => {
  // //   const selected = params.row;
  // //   setSelectedRows((prevSelectedRows) => [...prevSelectedRows, selected]); // Añade la fila seleccionada al estado
  // // };
     useEffect(() => {
        if (col) {
          setcolar(col);
          // Puedes usar el id para hacer llamadas al backend o manejar lógica adicional
        }
      }, [col]);


  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  const handleCloseModalSucces = () => {
    setRegistrationSuccess(false);
    onClose();
  };

  const handleUpdate = async () => {
  let hasErrors = false;
  const newFieldErrors = {};

  rows.forEach((row, index) => {
    if (!row.serie || row.serie.length !== 16) {
      newFieldErrors[`serie_${index}`] = "Ingresá una serie valida";
      hasErrors = true;
    } else if (rowValidation[index] !== 'valid') {
      newFieldErrors[`serie_${index}`] = "La serie no es válida o ya tiene un colar";
      hasErrors = true;
    }
    if (!row.descripcion) {
      newFieldErrors[`descripcion_${index}`] = "El producto no se cargó correctamente";
      hasErrors = true;
    }
  });

  if (hasErrors) {
    setFieldErrors(newFieldErrors);
    toast.error("Corregí los errores antes de guardar", { position: "top-center" });
    return;
  }

  setIsLoading(true);
  try {
    await putAddInterfolacion(colar, rows);
    toast.success("Chapa agregada correctamente", { position: "top-center" }); // ✅
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setRows([{ id: 1, serie: "", descripcion: "" }]);
    setRowValidation({});
    onClose();
  } catch (error) {
    console.error("❌ Error al agregar chapa:", error);
    toast.error(error.message || "Error general", { position: "top-center" });
    setRegistrationError(true);
    setError(error.message);
  } finally {
    setTimeout(() => setIsLoading(false), 1000);
  }
};

  const generateZPL = async (values) => {
    const qrImageUrl = await QRCode.toDataURL(values.colar, {
      errorCorrectionLevel: "H",
    }).catch((error) => {
      console.error("Error generando el QR:", error);
      return null; // Retorna null en caso de error
    });

    const formatText = (text, maxLength) => {
      const words = text.split(" ");
      let lines = [];
      let currentLine = "";

      words.forEach((word) => {
        if ((currentLine + word).length > maxLength) {
          lines.push(currentLine);
          currentLine = word;
        } else {
          currentLine += (currentLine ? " " : "") + word;
        }
      });

      if (currentLine) lines.push(currentLine);
      return lines;
    };

    // Dividir la descripción y el código en líneas

    const descripcionLines = formatText(values.descripcion, 40); // o 40 según el tamaño de letra

    function generarBloqueDescripcion(
      startY,
      x,
      fontSizeY = 28,
      fontSizeX = 28,
      lineSpacing = 40
    ) {
      return descripcionLines
        .map((line, index) => {
          const y = startY - index * lineSpacing;
          return `^FO${y},${x}^A0R,${fontSizeY},${fontSizeX}^FD${line}^FS`;
        })
        .join("\n");
    }
    const bloqueDescripcion1 = generarBloqueDescripcion(300, 50);
    const bloqueDescripcion2 = generarBloqueDescripcion(300, 800);
    const bloqueDescripcion3 = generarBloqueDescripcion(300, 1600);

    let zpl = `
      ^XA
  ^POI
  ^PW820
  ^LL2420
  
  ^FO700,50^A0R,30,30^FDNumero de Serie:${values.colar}^FS
  ^FO650,50^A0R,25,30^FD${values.fecha}^FS
  
  ^FO580,50^A0R,30,30^FDCant. Chapa:^FS
  ^FO520,90^A0R,30,30^FD${values.cantidad}^FS
  
  ^FO580,300^A0R,30,30^FDPeso:^FS
  ^FO520,330^A0R,30,30^FD${values.peso}^FS
  
  ^FO420,50^A0R,25,30^FDFABRICA:${values.serie}^FS
  ^FO370,50^A0R,30,30^FD${values.cod}^FS
  
  ${bloqueDescripcion1}
  
  
  ^FO500,500^BQN,2,8^FDQA,${values.colar}^FS
  ^FO100,740^GB700,3,3,B,0^FS
  
  ^FO700,800^A0R,30,30^FDNumero de Serie:${values.colar}^FS
  ^FO650,830^A0R,25,30^FD${values.fecha}^FS
  
  ^FO580,800^A0R,30,30^FDCant. Chapa:^FS
  ^FO520,850^A0R,30,30^FD${values.cantidad}^FS
  
  ^FO580,1080^A0R,30,30^FDPeso:^FS
  ^FO520,1110^A0R,30,30^FD${values.peso}^FS
  
  ^FO420,800^A0R,25,30^FDFABRICA:${values.serie}^FS
  ^FO370,800^A0R,30,30^FD${values.cod}^FS
  
  ${bloqueDescripcion2}
  
  ^FO500,1350^BQN,2,8^FDQA,${values.colar}^FS
  ^FO100,1550^GB700,3,3,B,0^FS
  
  ^FO700,1600^A0R,30,30^FDNumero de Serie:${values.colar}^FS
  ^FO650,1630^A0R,25,30^FD${values.fecha}^FS
  
  ^FO580,1600^A0R,30,30^FDCant. Chapa:^FS
  ^FO520,1650^A0R,30,30^FD${values.cantidad}^FS
  
  ^FO580,1880^A0R,30,30^FDPeso:^FS
  ^FO520,1910^A0R,30,30^FD${values.peso}^FS
  
  ^FO420,1600^A0R,25,30^FDFABRICA:${values.serie}^FS
  ^FO370,1600^A0R,30,30^FD${values.cod}^FS
  ${bloqueDescripcion3}
  ^FO500,2150^BQN,2,8^FDQA,${values.colar}^FS
  
  ^XZ
  `;

    if (window.BrowserPrint) {
      // Asegúrate de que BrowserPrint está disponible
      window.BrowserPrint.getDefaultDevice(
        "printer",
        (device) => {
          if (device) {
            setPrinterInfo(
              `Dispositivo predeterminado encontrado: ${device.name}`
            );
            let zplCommand = zpl;

            // 3. Usar la función send para enviar los datos al dispositivo
            device.send(
              zplCommand,
              function (response) {},
              function (error) {
                console.error("Error al enviar datos:", error);
              }
            );
          } else {
            setPrinterInfo("No hay una impresora predeterminada configurada.");
          }
        },
        (error) => {
          setErrorMessage(
            `Error al obtener el dispositivo predeterminado: ${error}`
          );
        }
      );
    } else {
      setErrorMessage("BrowserPrint no está disponible.");
    }
  };

  const openModalCaballete = (rowId) => {
    setSelectedIndex(rowId); // Guarda el index seleccionado
    setModalOpen(true); // Abre el modal
  };
  const handleAddRow = () => {
    setRows([...rows, { id: rows.length + 1, serie: "", descripcion: "" }]);
  };

  const handleRemoveRow = (index) => {
  const updatedRows = rows.filter((_, i) => i !== index);
  setRows(updatedRows);
  setRowValidation(prev => {
    const updated = { ...prev };
    delete updated[index];
    return updated;
  });
};
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-horario-title"
      aria-describedby="modal-horario-description"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.5)" }, // Ajustar opacidad del fondo
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: colors.primary[600],
          paddingLeft: "10px",
          paddingTop: "5px",
          paddingRight: "10px",
          paddingBottom: "10px!important",
          zIndex: 1500,
        }}
      >
        <Box m="0px">
          <Box display="flex" justifyContent="space-between" p={2}>
            <h1 id="owner-modal-title">Agregar Chapas</h1>
          </Box>
        </Box>
        <Box
          alignItems="center"
          width="45vw"
          height="75vh"
          backgroundColor={colors.primary[400]}
        >
          <Box
            mt={2}
            sx={{
              height: "90%",
              width: "100%",
              margin: "auto",
              // backgroundColor: "red",
            }}
          >
            {/* Botón Agregar con texto "Item" */}
            <Box
              display="flex"
              alignItems="center"
              mb={2}
              sx={{ backgroundColor: "#cedc00", color:"rgb(36 43 67)" }}
            >
              <IconButton  onClick={handleAddRow}>
                <AddCircleIcon sx={{marginLeft:"1vh", color:"#101624"}} />
              </IconButton>
              <Typography variant="body1" onClick={handleAddRow}  sx={{ cursor: "pointer" }}>
                Agregar un Item
              </Typography>
            </Box>

            {/* Grid dinámico */}
            {rows.map((row, index) => (
              <Grid
                container
                spacing={2}
                alignItems="center"
                width="79vw"
                key={index}
                sx={{
                  marginBottom: "10px",
                  marginLeft: "20px",
                  width: "97%",
                  height: "10%",
                }}
              >
                <Grid item xs={1}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="ID"
                    value={row.id}
                    InputProps={{
                      readOnly: true, // Hacer que el campo sea de solo lectura
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label={`Serie ${index + 1}`}
                    value={row.serie}
                    onChange={(e) => {
                      const newRows = [...rows];
                      newRows[index].serie = e.target.value;
                      setRows(newRows);
                       setSerieValue(e.target.value);
                        setSelectedIndex(index);
                    }}
                    error={!!fieldErrors[`serie_${index}`]}
                    helperText={fieldErrors[`serie_${index}`]}
                  />
                </Grid>
                {/* Campo Producto y botón en la misma fila */}
                <Grid item xs={9}>
                  <Box display="flex" alignItems="center">
                    <TextField
                      sx={{ minWidth: "10vw"}}
                      fullWidth
                      variant="outlined"
                      label="Producto"
                      value={row.descripcion}
                      onChange={(e) => {
                        const newRows = [...rows];
                        newRows[index].descripcion = e.target.value;
                        setRows(newRows);
                      }}
                      error={!!fieldErrors[`descripcion_${index}`]}
                      helperText={fieldErrors[`descripcion_${index}`]}
                    />
                    <IconButton
                      color="secondary"
                      onClick={() => handleRemoveRow(index)}
                      sx={{ marginLeft: "7px" }}
                    >
                      <RemoveCircleOutlineIcon />
                    </IconButton>
                  </Box>
                </Grid>
              </Grid>
            ))}
          </Box>
        </Box>
        <Box
          sx={{
            width: "45vw",
            height: "9vh",
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1.5vh",
          }}>
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          onClick={handleUpdate}
          sx={{
            backgroundColor: "rgb(206, 220, 0)",
            border: "none",
            color: "black",
            height: "6vh",
            width: "9vw",
            borderRadius: "20px",
            cursor: "pointer",
            marginRight: "1vw",
            "&:hover": { backgroundColor: "rgb(177, 196, 6)" },
          }}
          startIcon={<SaveIcon />} // Ícono de guardar
        >
          Guardar
        </Button>
        </Box>

        <ModalError
          open={registrationError}
          onClose={handleCloseModalError}
          error={error}
        />
        <ModalCharge isLoading={isLoading} />
        <ModalSuccess
          open={registrationSuccess}
          onClose={handleCloseModalSucces}
        />
      </Box>
    </Modal>
  );
};

export default ModalInsertInterfo;